import { Divider } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import React from "react";

function ExperienceList() {
    return (
        <React.Fragment>
            <Typography p={1} m={1} variant="h5 " component="h2" gutterBottom>
                Writer
      </Typography>
            <Typography variant="body1" component="p" gutterBottom>
                <Link href="#">Youth Carnival - Part-time</Link>
            </Typography>
            <Typography variant="body2" component="p" gutterBottom>
                May 2018 - May 2019 - 1 yr 1 mo
      </Typography>
            <Divider />
            <Typography p={1} m={1} variant="h5 " component="h2" gutterBottom>
                Managing Editor
      </Typography>
            <Typography variant="body1" component="p" gutterBottom>
                <Link href="#">Tottho Upatto - Full-time</Link>
            </Typography>
            <Typography variant="body2" component="p" gutterBottom>
                July 2017 - Sep 2018 - 1 yr 5 mo
      </Typography>
            <Divider />
            <Typography p={1} m={1} variant="h5 " component="h2" gutterBottom>
                Teacher Assistant
      </Typography>
            <Typography variant="body1" component="p" gutterBottom>
                <Link href="#">Kabi Nazrul College - Contract</Link>
            </Typography>
            <Typography variant="body2" component="p" gutterBottom>
                Jan 2018 - Apr 2018 - 4 mo
      </Typography>
            <Divider />
        </React.Fragment>
    );
}

export default ExperienceList;
